module.exports = __webpack_public_path__ + "static/contact-3f8615e1c5020510928f425db414d987.png";